export default __webpack_public_path__ + "static/media/skynet-loader.f6570607.gif";